const STORE = {
    CLOSED: 'Closed'
};

const URL = {
    SHOP_MY_STORE: '/happening/shop-my-store',
    SHOP_SAME_DAY: '/happening/shop-same-day',
    SEPHORA_NEAR_ME: '/happening/stores/sephora-near-me',
    HAPPENING_SERVICES: '/happening/services',
    NEW_BEAUTY_PRODUCTS: '/beauty/new-beauty-products',
    COMMUNITY_GALLERY: '/community/gallery'
};

export {
    STORE, URL
};
